export const reportTypes = {
  topN: 'Top-N',
  devices: 'Devices',
  xtendPackages: 'Xtend Installed Packages',
  policyViolations: 'Policy Violations',
  topPrograms: 'Top Programs',
  topUrls: 'Top Urls',
};
export const primaryEntityTypes = {
  applications: 'applications',
  infraElements: 'infra-elements',
  users: 'users',
  servers: 'servers',
  programs: 'Programs',
  urls: 'Urls',
};
export const reportInfo = [
  {
    category: 'Application and User Analytics',
    isActive: false,
    description: `
      <h4>Application and User Analytics</h4>
      <b>When to use?</b>
      <p>This set of reports provides digital experience and user productivity analytics.</p>
      <b>Who should use?</b>
      <p>IT Operations, Application Admins, CXO, Business Owner, etc.</p>
      <b>Who should use?</b>
      <p>DevOps, Operations, SRE, Developer, QA, Support, Business owner.</p>
      <b>Tips for using</b>
      <ul>
        <li>Make sure XOME is collecting flow and/or wire data.</li>
        <li>For some reports, endpoint data (using xTend) may be needed.</li>
      </ul>
    `,
    types: [
      {
        name: 'Top Application Servers',
        isActive: false,
        type: reportTypes.topN,
        primaryEntityType: primaryEntityTypes.servers,
        description: `
          <h4>Top Application Servers</h4>
          <b>When to use?</b>
          <p>To report a list of top application servers by usage volume.</p>
          <b>Who should use?</b>
          <p>IT Operations, Network Admins, Applications Admins, Infra Admins, CXO, Business Owner, etc.</p>
          <b>Tips for using</b>
          <ul>
            <li>Make sure XOME is collecting flow and/or wire data. </li>
          </ul>
        `,
      },
      {
        name: 'Top Application Usage',
        isActive: false,
        type: reportTypes.topN,
        primaryEntityType: primaryEntityTypes.applications,
        description: `
          <h4>Top Application Usage</h4>
          <b>When to use?</b>
          <p>To report a list of top applications by usage volume.</p>
          <b>Who should use?</b>
          <p>IT Operations, Network Admins, Applications Admins, Infra Admins, CXO, Business Owner, etc.</p>
          <b>Tips for using</b>
          <ul>
            <li>Make sure XOME is collecting flow and/or wire data. </li>
          </ul>
        `,
      },
      {
        name: 'Top Users',
        isActive: false,
        type: reportTypes.topN,
        primaryEntityType: primaryEntityTypes.users,
        description: `
          <h4>Top Users</h4>
          <b>When to use?</b>
          <p>To report a list of top users by usage volume. </p>
          <b>Who should use?</b>
          <p>IT Operations, Network Admins, Applications Admins, Infra Admins, CXO, Business Owner, etc.</p>
          <b>Tips for using</b>
          <ul>configStep
          <b>When to use?</b>
          <p>To report a list of top applications servers by usage volume.</p>
          <b>Who should use?</b>
          <p>IT Operations, Applications Admins, Infra Admins, CXO, Business Owner, etc.</p>
          <b>Tips for using</b>
          <ul>
            <li>Make sure XOME is collecting flow and/or wire data.</li>
          </ul>
        `,
      },
      {
        name: 'Top Devices',
        isActive: false,
        type: reportTypes.devices,
        primaryEntityType: null,
        description: `
          <h4>Top Devices</h4>
          <b>When to use?</b>
          <p>To report a list of all applications/software on the devices.</p>
          <b>Who should use?</b>
          <p>Security Operations, Security Admins, Infra Admins, CXO, Business Owner, etc.</p>
          <b>Tips for using</b>
          <ul>
            <li>Make sure xTends are deployed on end devices
            (such as laptops, desktops, servers, etc.) and are collecting data.
            </li>
          </ul>
        `,
      },
    ],
  },
  {
    category: 'Network and Infra Analytics',
    isActive: false,
    description: `
      <h4>Network and Infra Analytics</h4>
      <b>When to use?</b>
      <p>This set of reports provides analytics on network and other infrastructure nodes.</p>
      <b>Who should use?</b>
      <p>IT Operations, Network Admins, Infra Admins, CXO, Business Owner, etc. </p>
      <b>Who should use?</b>
      <p>DevOps, Operations, SRE, Developer, QA, Support, Business owner.</p>
      <b>Tips for using</b>
      <ul>
        <li>Make sure XOME is collecting network and infrastructure data.</li>
      </ul>
    `,
    types: [
      {
        name: 'Top Infra Elements',
        isActive: false,
        type: reportTypes.topN,
        primaryEntityType: primaryEntityTypes.infraElements,
        description: `
          <h4>Top Infra Elements</h4>
          <b>When to use?</b>
          <p>To report a list of top infra elements.</p>
          <b>Who should use?</b>
          <p>Security Operations, Security Admins, Infra Admins, CXO, Business Owner, etc.</p>
          <b>Tips for using</b>
          <ul>
            <li>Make sure xTends are deployed on end devices
            (such as laptops, desktops, servers, etc.) and are collecting data.
            </li>
          </ul>
        `,
      },
    ],
  },
  {
    category: 'Security and Threat Analytics',
    isActive: false,
    description: `
      <h4>Security and Threat Analytics</h4>
      <b>When to use?</b>
      <p>This set of reports provides security and threat analytics of IT infrastructure.</p>
      <b>Who should use?</b>
      <p>Security admins, CXO, Business Owner, etc.</p>
      <b>Tips for using</b>
      <ul>
        <li>Make sure XOME is collecting flow and/or wire data.</li>
        <li>For some reports, endpoint data (using xTend) may be needed.</li>
      </ul>
    `,
    types: [
      {
        name: 'Installed Packages/Software',
        isActive: false,
        type: reportTypes.xtendPackages,
        primaryEntityType: null,
        description: `
          <h4>Installed Packages/Software</h4>
          <b>When to use?</b>
          <p>To report a list of all installed packages and software.</p>
          <b>Who should use?</b>
          <p>Security Operations, Security Admins, Infra Admins, CXO, Business Owner, etc.</p>
          <b>Tips for using</b>
          <ul>
            <li>Make sure xTends are deployed on end devices
            (such as laptops, desktops, servers, etc.) and are collecting data.
            </li>
          </ul>
        `,
      },
      {
        name: 'Policy Violations',
        isActive: false,
        type: reportTypes.policyViolations,
        primaryEntityType: null,
        description: `
          <h4>Policy Violations</h4>
          <b>When to use?</b>
          <p>Listing all policy violations across endpoints.</p>
          <b>Who should use?</b>
          <p>Security Operations, Security Admins, Infra Admins, etc.</p>
          <b>Tips for using</b>
          <ul>
            <li>Make sure xTend has been deployed to the endpoints.</li>
            <li>Define policies: <b>Authorized SSID(s)</b>, <b>Authorized DNS Server(s)</b>, or
            <b>Unauthorized Domain(s)</b>.
          </ul>
        `,
      },
      {
        name: 'Top Programs',
        isActive: false,
        type: reportTypes.topPrograms,
        primaryEntityType: primaryEntityTypes.programs,
        description: `
          <h4>Top Programs</h4>
          <b>When to use?</b>
          <p>To list the top programs across all endpoints and top programs per endpoint.</p>
          <b>Who should use?</b>
          <p>Security Operations, Security Admins, Infra Admins, Business Owner, etc.</p>
          <b>Tips for using</b>
          <ul>
            <li>Make sure xTend has been deployed to the endpoints.</li>
          </ul>
        `,
      },
      {
        name: 'Top Websites',
        isActive: false,
        type: reportTypes.topUrls,
        primaryEntityType: primaryEntityTypes.urls,
        description: `
          <h4>Top Websites</h4>
          <b>When to use?</b>
          <p>To list the top websites visited across all endpoints and top websites per endpoint.</p>
          <b>Who should use?</b>
          <p>Security Operations, Security Admins, Infra Admins, etc.</p>
          <b>Tips for using</b>
          <ul>
            <li>Make sure xTend has been deployed to endpoints.</li>
          </ul>
        `,
      },
    ],
  },
];
export const reportStatuses = {
  ready: 'ready',
  pending: 'pending',
};
